function getUser() {
  return this.axios.get('/user')
}

const user = (axios) => ({ axios, get: getUser })

export default user
